var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsUpCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 27 27",
    width: 27,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.333333 15.228v4.490667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5266667 18.8773333c0 .6200317.502635 1.1226669 1.1226666 1.1226669h4.696c.3752247.0001992.7256197-.1875124.9333334-.5000002l1.2-1.8026667c.1226967-.1849723.1880933-.4020332.1880001-.624v-2.196c0-.2977497-.1182807-.5833043-.3288216-.7938452-.2105408-.2105408-.4960955-.3288214-.7938452-.3288214h-2.0773333v-1.9093334c0-.6509596-.5277071-1.1786683-1.1786667-1.1786683h-.6733333c-.3949473-.0006716-.7611261.2064752-.964.545335l-1.804 3.008c-.2092885.3487975-.3198935.7478973-.32 1.1546667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.17529333 22.87768-.84196 3.7889867 3.78898667-.84196c5.1041742 3.5759778 12.0950315 2.6570137 16.1016334-2.1165963s3.6995038-11.8179178-.7073211-16.22474274c-4.4068249-4.40682489-11.4511327-4.71392298-16.22474267-.70732109-4.77361001 4.00660193-5.6925741 10.99745923-2.1165963 16.10163343z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpCircle);
export default __webpack_public_path__ + "static/media/thumbs-up-circle.cbf9421bae4b2772f522f9fc8932511b.svg";
export { ForwardRef as ReactComponent };